import "../styles/Donation.css"
import TopNavBar from "../components/TopNavBar";

//The donation page.
const Donation = () => {
    return (
        <div id="donation">
            <TopNavBar />
            <header id="donateHeader">
                <section className="headerTitle">

                    <h1 className="threeD">3D</h1>

                    <h3 className="musicAcademy">Music Academy Inc.</h3>

                </section>
                <div id="thankYouNoteContainer">
                    <h1 id="thankYouNote">Thank you for your contribution</h1>
                    <p id="addendum">Your donation will help us provide students with education through the art of music.</p>
                </div>
            </header>

            <main id="donateMain">
                <section id="donationButtons">
                    <form action="https://buy.stripe.com/28obJ18Id13Y968144">
                        <button type="submit" className="donationButton">$1.00</button>
                    </form>
                    <form action="https://buy.stripe.com/8wM7sL3nT2824PS8wx">
                        <button type="submit" className="donationButton">$5.00</button>
                    </form>
                    <form action="https://buy.stripe.com/5kA14n8IdfYS2HKeUW">
                        <button type="submit" className="donationButton">$10.00</button>
                    </form>
                    <form action="https://buy.stripe.com/28o6oHgaFaEybegdQT">
                        <button type="submit" className="donationButton">$25.00</button>
                    </form>
                    <form action="https://buy.stripe.com/28o4gz7E9bICgyA7sw">
                        <button type="submit" className="donationButton">$50.00</button>
                    </form>
                    <form action="https://buy.stripe.com/5kA9AT6A53c64PS9AF">
                        <button type="submit" className="donationButton">$100.00</button>
                    </form>
                </section>
            </main>
            <footer id="donateFooter">
                <p>© 2022 3D Music Academy Inc.</p>
            </footer>

        </div>
    )
}

export default Donation;